import { IAppContext } from 'App/AppContext';
import { FeatureTypes, hasUserFeature, hasUserFeatureGenericManager } from 'services/Auth/featurePermissions';

export const canUseTaskViews = (appContext: IAppContext): boolean => {
  const login = appContext.user?.login;
  if (!appContext.isAuthenticated || appContext.isAuthInProgress || !login?.tenantId) {
    return false;
  }

  const tenantIsRegisteredAndUserHasRole =
    login.tenantLicensed === false && login.userLicensed === false && hasUserFeatureGenericManager(appContext);
  if (!login.userLicensed && !tenantIsRegisteredAndUserHasRole) {
    return false;
  }

  return hasUserFeature(appContext, FeatureTypes.Tasks);
};
